import { ComponentProps } from 'src/lib/ComponentProps';

import { FieldEditFrame } from 'src/utils/customFieldEditFrame';

import { EditorHelp } from 'src/components/layout/_EditorHelp/_EditorHelp';

import { VideoItem } from '../_VideoPlayer/VideoItem';
import VideoPlayer from '../_VideoPlayer/VideoPlayer';

type VideoComponentProps = ComponentProps & {
	fields: {
		YouTubeVideos?: VideoItem[];
		VimeoVideos?: VideoItem[];
		ResourceVideos?: VideoItem[];
	};
};

export default function VideoCollection(props: VideoComponentProps): JSX.Element {
	const videoCollection: VideoItem[] = [];

	if (props.fields?.VimeoVideos && props.fields.VimeoVideos.length > 0) {
		Array.prototype.push.apply(videoCollection, props.fields.VimeoVideos);
	}
	if (props.fields?.YouTubeVideos && props.fields.YouTubeVideos.length > 0) {
		Array.prototype.push.apply(videoCollection, props.fields.YouTubeVideos);
	}
	if (props.fields?.ResourceVideos && props.fields.ResourceVideos.length > 0) {
		Array.prototype.push.apply(videoCollection, props.fields.ResourceVideos);
	}

	return (
		<FieldEditFrame
			itemId={props.rendering?.dataSource ?? ''}
			fields={['VimeoVideos', 'YouTubeVideos', 'ResourceVideos']}
			header="Select Videos"
		>
			<EditorHelp text="Click here to change which videos appear" />
			{videoCollection?.map((video, index) => (
				<VideoPlayer video={video} key={index} />
			))}
		</FieldEditFrame>
	);
}
